export default __webpack_public_path__ + "static/media/casino.fcf2774b.png";